import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { getReturnsExclusionsMessage } from "./utils/getReturnsExclusionsMessage";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./ReturnsExclusions.module.scss";

type Props = {
  browsePageHierarchy: Array<{ categoryId: string }>;
  sellingProductType?: string;
};

export function ReturnsExclusions({
  browsePageHierarchy,
  sellingProductType = "",
}: Props) {
  const returnsExclusionsMessage = getReturnsExclusionsMessage(
    browsePageHierarchy,
    sellingProductType,
  );

  if (!returnsExclusionsMessage) return null;

  return (
    <Message
      type="information"
      dataTestId="returns:exclusions-message"
      title={returnsExclusionsMessage.title}
      body={
        <>
          <p>{returnsExclusionsMessage.message}</p>
          <div className={styles.buttonWrapper}>
            <UnderlinedButton
              tag="a"
              data-testid="returns:policy-link"
              className={styles.button}
              href="https://www.johnlewis.com/customer-services/returns?dt=informationOnOurReturnsPolicy"
            >
              Read our returns policy
            </UnderlinedButton>
          </div>
        </>
      }
    />
  );
}
